import { FC, useState } from "react";
import { Radio, Button, Spin } from "antd";
import { formatDownloadFileNameDate, formatNumber } from "@utils/helpers";
import * as XLSX from "xlsx";
import { cloneDeep } from "lodash";
import DashboardService from "@services/dashboard.service";

type TDownloadProps = {
  columns: any;
  downloadType: any;
  sortType: any;
  sortBy: any;
  reminderStartFilter: any;
  reminderEndFilter: any;
  totalUser: any;
  onClose: any;
  totalUserCount: any;
  searchOn: any;
  downloadColData?: any;
};

const DownloadSection: FC<TDownloadProps> = ({
  totalUser,
  totalUserCount,
  downloadColData,
  onClose,
  downloadType,
  sortType,
  sortBy,
  reminderStartFilter,
  reminderEndFilter,
  searchOn,
}: TDownloadProps) => {
  const [columnsType, setColumnsType] = useState("detail");
  const [showLoader, setShowLoader] = useState(false);
  const setColumnsTypeRadio = (event: any) => {
    setColumnsType(event.target.value);
  };

  const downloadLite = () => {
    let ccData = [...totalUser];
    let data: any[] = [];
    if (columnsType === "lite") {
      data = ccData.map((row: any) => {
        const obj: any = {};
        downloadColData.filter((col: any) => col.isSelected).forEach((col: any) => (obj[col.dataIndex] = row[col.dataIndex]));
        downloadColData.forEach((col: any) => {
          if (col.isSelected) {
            // obj[col.dataIndex] = !isEmpty(row[col.dataIndex]?.toString()) ? row[col.dataIndex] : "--";
            if (col.dataIndex === "member_id") {
              obj[col.dataIndex] = row[col.dataIndex] !== null ? (isNaN(Number(row[col.dataIndex])) ? row[col.dataIndex] : "'" + row[col.dataIndex]) : row[col.dataIndex];
            } else {
              obj[col.dataIndex] = row[col.dataIndex];
            }
          }
        });
        return obj;
      });
    } else {
      data = ccData.map((item: any) => {
        let obj = { ...item };

        // Object.keys(obj).forEach(function (key) {
        //   if (isEmpty(obj[key]?.toString())) {
        //     obj[key] = "--";
        //   }
        // });
        obj["member_id"] = obj["member_id"] !== null ? (isNaN(Number(obj["member_id"])) ? obj["member_id"] : "'" + obj["member_id"]) : obj["member_id"];
        return obj;
      });
    }

    const dataHeaderSelected = Object.keys(data[0]);
    let customizedData: any[] = [];
    let headersCreatedForFileDownload: any = {};
    let copyColumns = cloneDeep(downloadColData);
    let colOrderMap: Map<any, any> = new Map();

    copyColumns.forEach((element: any) => {
      if ((element?.subColumns?.length > 0 || element?.children?.length > 0) && element.tableHeaderName) {
        element.subColumns
          ? element?.subColumns.forEach((el: any) => colOrderMap.set(el.dataIndex, element.order))
          : element?.children.forEach((el: any) => colOrderMap.set(el.dataIndex, element.order));
      } else if (element.tableHeaderName) {
        colOrderMap.set(element.dataIndex, element.order);
      }
    });
    let sorteddataHeaderSelected = dataHeaderSelected.sort((a: any, b: any) => ((colOrderMap.get(a) || 9999) < (colOrderMap.get(b) || 9999) ? -1 : 1));
    copyColumns.forEach((element: any) => {
      if ((element?.subColumns?.length > 0 || element?.children?.length > 0) && element.tableHeaderName) {
        element.subColumns
          ? element?.subColumns.forEach((el: any) => (headersCreatedForFileDownload[el.dataIndex] = el.tableHeaderName))
          : element?.children.forEach((el: any) => (headersCreatedForFileDownload[el.dataIndex] = el.tableHeaderName));
      } else if (element.tableHeaderName) {
        headersCreatedForFileDownload[element.dataIndex] = element.tableHeaderName;
      }
    });

    customizedData = data.map((entries) => {
      let customizedEntries: any = {};
      for (let i = 0; i < sorteddataHeaderSelected.length; i++) {
        if (headersCreatedForFileDownload[sorteddataHeaderSelected[i]]) customizedEntries[headersCreatedForFileDownload[sorteddataHeaderSelected[i]]] = entries[sorteddataHeaderSelected[i]];
      }
      return customizedEntries;
    });

    const fileName = `Inpatient_Management_Report_${columnsType === "lite" ? "Lite" : "Detail"}_${formatDownloadFileNameDate(new Date())}.csv`;
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(customizedData);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Inpatient Management report");
    XLSX.writeFile(wb, fileName);
  };

  const downloadAllMembers = () => {
    setShowLoader(true);
    let colList: any[] = [];
    cloneDeep(downloadColData).forEach((col: any) => {
      if (col.subColumns.length > 0) {
        col.subColumns.forEach((subcol: any) => {
          if (col.tableHeaderName) {
            colList.push({ key: subcol.key, tableHeaderName: subcol.tableHeaderName });
          }
        });
      }
      if (col.tableHeaderName && !(col.subColumns.length > 0)) {
        colList.push({ key: col.key, tableHeaderName: col.tableHeaderName });
      }
    });
    if (columnsType === "lite") {
      colList = [];
      cloneDeep(downloadColData)
        .sort((a: any, b: any) => (a.order < b.order ? -1 : 1))
        .forEach((col: any) => {
          if (col.subColumns.length > 0) {
            col.subColumns
              .sort((a: any, b: any) => (a.order < b.order ? -1 : 1))
              .forEach((subcol: any) => {
                if (col.isSelected && col.tableHeaderName) {
                  colList.push({ key: subcol.key, tableHeaderName: subcol.tableHeaderName });
                }
              });
          }
          if (col.isSelected && col.tableHeaderName && !(col.subColumns.length > 0)) {
            colList.push({ key: col.key, tableHeaderName: col.tableHeaderName });
          }
        });
    }
    DashboardService.downloadInpatientReport({
      columns: colList,
      startDate: reminderStartFilter,
      endDate: reminderEndFilter,
      sortBy: sortBy,
      sortType: sortType,
      searchOn,
      columnsType,
    }).subscribe({
      next: (v) => {
        if (v.data.status === "OK") window.open(v.data.data.fileURL, "_blank");
        setShowLoader(false);
      },
      error: (e) => {
        setShowLoader(false);
      },
    });
  };

  return (
    <div className="dwonloadSectionWrap">
      <div className="inputSection">
        <div className="checkboxSection">
          <p className="checkAllSection">
            <span className="f16 w500 number">{downloadType === "all" ? totalUserCount : totalUser.length > 0 ? formatNumber(totalUser.length) : 0}</span>
            <span className="f16 w500 details">Members selected</span>
            <br />
            {totalUser.length > 0 ? (
              <span className="f12 subDetail">(Can select upto 1 million members only)</span>
            ) : (
              <span className="f12 subDetail" style={{ color: "#e75547" }}>
                (Can select upto 1 million members only)
              </span>
            )}
          </p>
        </div>
      </div>
      <div className="downloadTypeSection">
        <Radio.Group onChange={setColumnsTypeRadio} value={columnsType}>
          <Radio disabled={totalUser.length === 0} value={"detail"}>
            <div className="detailWrap">
              <p className="detailHead">Download Detail</p>
              <p className="f12 detailSubHead">This version will download all columns</p>
            </div>
          </Radio>
          <Radio disabled={totalUser.length === 0} value={"lite"}>
            <div className="detailWrap">
              <p className="detailHead">Download Lite</p>
              <p className="f12 detailSubHead">This version will download only columns that are visible on screen</p>
            </div>
          </Radio>
        </Radio.Group>
      </div>
      <div className="downloadActionSection cancel-button">
        <Button type="text" size={"large"} onClick={onClose}>
          Cancel
        </Button>
        <Spin spinning={showLoader}>
          <Button disabled={totalUser.length === 0} type="primary" size={"large"} className="f16 w500 downloadButton" onClick={downloadType === "all" ? downloadAllMembers : downloadLite}>
            <i className="icon-download" /> Download XLS
          </Button>
        </Spin>
      </div>
    </div>
  );
};

export default DownloadSection;
